// extracted by mini-css-extract-plugin
export default {"body":"PageLoader_body__tk5vI"};